import type { PaymentCard } from "../types";

interface RawCardOnFile {
  brand?: string | null;
  last4?: string | null;
  expMonth?: number | null;
  expYear?: number | null;
  cardHolderName?: string | null;
}

export function normalizeCardOnFile(
  cardOnFile: RawCardOnFile | null | undefined,
): PaymentCard | null {
  if (!cardOnFile) return null;

  return {
    brand: cardOnFile.brand!,
    last4: cardOnFile.last4!,
    expMonth: cardOnFile.expMonth!,
    expYear: cardOnFile.expYear!,
    cardHolderName: cardOnFile.cardHolderName!,
  };
}
